import React, { useState } from 'react';
import { AppBar } from '@mui/material';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import OnlyWithFunction, { isValidUser } from '../OnlyWithFunctions';
import { Link } from 'react-router-dom';
import TopLogoDiv from './TopLogoDiv';
import { AuthContext } from '../App';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { StyledButton } from './StyledButton';
import { useQueryClient } from '@tanstack/react-query';
import { logout } from '../services/logout';
import { Roles } from "enums/roles";

const Header = (props) => {
  const { state: AuthState, dispatch } = useContext(AuthContext);
  const theme = useTheme();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleLogout = (event) => {
    event.preventDefault();
    navigate('/');
    queryClient.removeQueries();
    dispatch({ type: 'LOGOUT', payload: { isAuthenticated: false } });
    logout().then((res) => {
      console.log('res per logout:', res);
    }).catch(err => console.error(err));
    localStorage.clear();
  };

  const [openModalDuplicaAdv, setOpenModalDuplicaAdv] = useState(false);
  const clickDuplicaAdvButton = () => {
    setOpenModalDuplicaAdv(!openModalDuplicaAdv);
  };
  const handleDuplicaAdvModalClose = () => {
    setOpenModalDuplicaAdv(false);
  };

  return (
    <div
      style={{
        padding: 0,
        flex: '0 1 auto',
      }}
    >
      <AppBar
        position="static"
        elevation={0}
        sx={{
          display: 'flex',
          position: 'relative',
          border: 'solid 1px',
          bgcolor: 'white',
          width: '100%',
          //minHeight: '25em', // Altezza uniforme e maggiore
          justifyContent: 'center',
        }}
      >
{/*        {AuthState.isAuthenticated && (
          <Box
            sx={{
              position: 'absolute',
              top: '1rem', // Posizionato in alto
              left: '2rem', // Spostato leggermente a destra
            }}
          >
            <TopLogoDiv />
          </Box>

        )}*/}
        {AuthState.isAuthenticated && (
          <Box sx={{ width: '100%' }}>
            {/* Contenitore principale che contiene il logo e il contenuto centrato */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',  // Contenuto centrato orizzontalmente
                alignItems: 'flex-end',  // Allinea tutto in basso
                position: 'relative',
                width: '100%',
                //paddingX: 2,  // Un po' di padding ai lati
              }}
            >
              {/* Box che contiene il logo */}
              <Box
                sx={{
                  position: 'relative',
                  left: 0,  // Logo posizionato a sinistra
                  bottom: 0,  // Logo allineato in basso
                  paddingLeft: 2,  // Un po' di spazio a sinistra per il logo
                  paddingRight: 2
                }}
              >
                <TopLogoDiv />
              </Box>

              {/* Box che contiene il contenuto centrato */}
              <Box
                sx={{
                  flexGrow: 1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  marginBottom: '10px'
                }}
              >
                {props.header}
              </Box>
            </Box>

            {/* Linea blu decorativa sotto */}
            <Box
              sx={{
                width: '100%',
                height: '8px',
                bgcolor: '#19668C',
              }}
            />
          </Box>
        )}





        <Grid container direction="row" alignItems="center" sx={{ height: '100%' }}>
{/*          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {props.header}
            <Box
              sx={{
                width: '100%',
                height: '8px', // Barra inferiore
                bgcolor: '#19668C',
                marginTop: '1rem',
              }}
            />
          </Grid>*/}
          {AuthState.isAuthenticated && (
            <>
              <Grid container alignItems="flex-end">
                <Grid xs={12} item sx={{ height: '4rem', marginTop: '1em' }}>
                  <Grid container justifyContent="space-between" alignItems="center">
                    <Box
                      sx={{
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        width: '50%',
                        display: 'flex',
                      }}
                    >
                      {props.showHome && (
                        <StyledButton
                          sx={{
                            color: theme.palette.black.main,
                            backgroundColor: theme.palette.grey.light,
                            border: 'none',
                            ml: '2vw',
                          }}
                          component={Link}
                          to="/"
                        >
                          <Typography variant="caption">HOME ADV</Typography>
                        </StyledButton>
                      )}
                      {props.showRichiesta && (
                        <OnlyWithFunction acceptedFunction="NUOVA_ADV">
                          <StyledButton
                            sx={{
                              marginLeft: '2vw',
                              color: theme.palette.black.main,
                              backgroundColor: theme.palette.grey.light,
                              border: 'none',
                            }}
                            component={Link}
                            to="/nuova-richiesta"
                          >
                            <Typography variant="caption">NUOVA RICHIESTA</Typography>
                          </StyledButton>
                        </OnlyWithFunction>
                      )}
                      {props.showStatistiche && (
                        <StyledButton
                          sx={{
                            color: theme.palette.black.main,
                            backgroundColor: theme.palette.grey.light,
                            border: 'none',
                            ml: '10px',
                          }}
                          component={Link}
                          to="/statistiche"
                        >
                          <Typography variant="caption">STATISTICHE</Typography>
                        </StyledButton>
                      )}
                      {props.showAccounting && (

                        <OnlyWithFunction acceptedFunction="UTENTE_INTERNO">
                          <StyledButton
                            sx={{
                              marginLeft: '10px',
                              color: theme.palette.black.main,
                              backgroundColor: theme.palette.grey.light,
                              border: 'none',
                            }}
                            component={Link}
                            to="/accounting"
                          >
                            <Typography variant="caption">
                              ACCOUNTING
                            </Typography>
                          </StyledButton>
                        </OnlyWithFunction>)}
                      {props.showSintesiAccounting &&
                        <OnlyWithFunction acceptedFunction={Roles.UTENTE_INTERNO.role}>
                          <StyledButton
                            sx={{
                              marginLeft: '10px',
                              color: theme.palette.black.main,
                              backgroundColor: theme.palette.grey.light,
                              border: 'none',
                            }}
                            component={Link}
                            to="/sintesi-accounting"
                          >
                            <Typography variant="caption">
                              SINTESI ACCOUNTING
                            </Typography>
                          </StyledButton>
                        </OnlyWithFunction>
                      }
                      {props.showMonitoraggio && (isValidUser(Roles.APPROVATORE_MONITORAGGIO.role) || isValidUser(Roles.MONITORAGGIO.role) || isValidUser(Roles.AML_DESK.role)) && (
                        <StyledButton
                          sx={{
                            color: theme.palette.black.main,
                            backgroundColor: theme.palette.grey.light,
                            border: 'none',
                            ml: '10px',
                          }}
                          component={Link}
                          to="/monitoring"
                        >
                          <Typography variant="caption">MONITORAGGIO</Typography>
                        </StyledButton>
                      )}
                      {props.showSoggettiTerzi && (isValidUser(Roles.APPROVATORE_MONITORAGGIO.role) || isValidUser(Roles.MONITORAGGIO.role) || isValidUser(Roles.AML_DESK.role)) && (
                        <StyledButton
                          sx={{
                            color: theme.palette.black.main,
                            backgroundColor: theme.palette.grey.light,
                            border: 'none',
                            ml: '10px',
                          }}
                          component={Link}
                          to="/soggetti-terzi-monitoraggio"
                        >
                            <Typography variant="caption">BAD PRESS SOGGETTI TERZI</Typography>
                        </StyledButton>
                         )}
                      {props.showAccountingMonitoraggio && (isValidUser(Roles.APPROVATORE_MONITORAGGIO.role) || isValidUser(Roles.MONITORAGGIO.role)) && (
                        <StyledButton
                          sx={{
                            color: theme.palette.black.main,
                            backgroundColor: theme.palette.grey.light,
                            border: 'none',
                            ml: '10px',
                          }}
                          component={Link}
                          to="/accounting-monitoraggio"
                        >
                          <Typography variant="caption">ACCOUNTING MONITORAGGIO</Typography>
                        </StyledButton>
                      )}
                      {/* {props.showDuplicaAdv && (
                        <StyledButton
                          onClick={clickDuplicaAdvButton}
                          sx={{
                            color: theme.palette.black.main,
                            backgroundColor: theme.palette.grey.light,
                            border: 'none',
                            ml: '10px',
                          }}
                        >
                          <Typography variant="caption" color="black" sx={{ fontSize: 10 }}>
                            <b>NUOVA</b> ADV
                          </Typography>
                          <AddIcon sx={{ color: theme.palette.blue.main, fontSize: 20 }} />
                        </StyledButton>
                      )} */}
                    </Box>

                    <Box
                      sx={{
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                        width: '50%',
                        display: 'flex',
                      }}
                    >
                      <StyledButton
                        sx={{
                          color: theme.palette.black.main,
                          backgroundColor: theme.palette.grey.light,
                          border: 'none',
                          marginRight: '10px',
                        }}
                        component={Link}
                        to="/"
                        onClick={handleLogout}
                      >
                        <Typography variant="caption" >DISCONNETTI</Typography>
                      </StyledButton>
                      <StyledButton
                        component={Link}
                        to="/profilo-utente"
                        sx={{
                          color: theme.palette.black.main,
                          backgroundColor: theme.palette.grey.light,
                          border: 'none',
                          marginLeft: '10px',
                          marginRight: '2vw'
                        }}
                      >
                        <Typography variant="caption">
                          {JSON.parse(localStorage.getItem('user')) || 'Utente'}
                        </Typography>
                      </StyledButton>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              {/* <DuplicaADVModal
                open={openModalDuplicaAdv}
                idNodoPratica={props.idNodoPratica}
                praticaProperties={props.praticaProperties}
                handleClose={handleDuplicaAdvModalClose}
                addPraticaToDettaglio={props.addPraticaToDettaglio}
              ></DuplicaADVModal> */}
            </>
          )}
        </Grid>
      </AppBar>
    </div>
  );
};

export default Header;
